export default "__VITE_ASSET__8794922b__"